module.exports = __webpack_public_path__ + "87bcf97940749888b31067ca39f3811b.MP3";